export const loggedInUserSelector = ({
  layoutReducer: { loggedInUserInfo = {} } = {},
}) => loggedInUserInfo;
